module.exports = __webpack_public_path__ + "img/austria.3458299d.png";